module.exports = __webpack_public_path__ + "static/img/magicQuest_port_lg.5945966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/magician-s-quest-banner-campaign/magicQuest_port_lg.jpg
// module id = 259
// module chunks = 2